var data_module = require('../../../public/javascripts/rwgps/data.js'),
  date_ext_module = require('../../../public/javascripts/rwgps/date_ext.js'),
  units_module = require('../../../public/javascripts/rwgps/units.js'),
  utils_module = require('../../../public/javascripts/rwgps/utils.js'),
  MetricsCalculator = require('../../../public/javascripts/js_maps/metrics_calculator.js');

// all the above modules will be attached to the rwgps variable which we'll export
var rwgps;

var Routes = window.Routes = window.Routes || {};

Routes.Common = {};

/**
 * TODO: Get the map.js functionality inside of this library. It will likely make sense to distribute its contents into other modules, so this module is a placeholder mostly.
 * @module maps-js
 */

/**
 * Defines core Ride with GPS Library functionality.
 *
 * @module base
 */

/**
 * Handles dependency management and initialization. Provides methods to get and set library properties.
 * Ran as a function, it expects a single argument that is a function to be executed once the rwgps
 * library has finished initializing.
 * @namespace
 * @class rwgps
 */
/**
 * @namespace rwgps
 */
var init = {
  isComplete: false,
  afterComplete: [afterInitComplete]
},
    R = module.exports = rwgps = function(onLoad) {
      if(init.isComplete) onLoad();
      else init.afterComplete.push(onLoad);
    },
    baseURL = '',
    baseSecureURL = '',
    options = {},
    $, MapJs;

R.csrfParams = function() {
  var data = {
    authenticity_token: encodeURIComponent(rwgps.config.authenticityToken)
  };
  data[rwgps.config.sessionKeyName] = rwgps.config.sessionKeyValue;
  return data;
}

// bootstrap
// NOTE: YHA is loading all their own reqs, so need to confirm they are loaded - if not, load them.  For now
//       we are just assuming they have been loaded.
//if(jQuery === undefined) {
//  head.js('http://code.jquery.com/jquery-1.5.1.min.js', function() {
//    $ = jQuery;
//  });
//} else {
$ = jQuery;
//}
//head.js(baseURL + '/javascripts/map.js', function() {
MapJs = window.Map;
//}).js('https://ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js')
//  .js(baseURL + '/javascripts/jquery/jquery.json-1.3.js')
//  .js(baseURL + '/javascripts/underscore-min.js', baseURL + '/javascripts/backbone-min.js');
//head(function() {
init.isComplete = true;
_.each(init.afterComplete, function(fn) { fn(); });
//});

// executed after all dependencies have been loaded
function afterInitComplete() {
  // this file should be reorganized??!! so that these dont have to be local vars for documentation to work!
  /** Site key. Overridden after this is loaded, defaults to rwgps
   * @property site
   */
  var site = 'rwgps';
  /** Whitelist for image extensions
   * @property imageExtensions
   */

  var imageExtRegEx = /(\.|\/)(gif|jpe?g|png)$/i;
  /** Whitelisting RegEx for images in multi-file uploader
   * @property imageExtRegex
   */

  var gpsExtRegEx = /(\.|\/)(gpx|tcx|kml|fit|kmz|zip|gz|tar)$/i;
  /** Whitelisting RegEx for images in multi-file uploader
   * @property gpsExtRegex
   */

  var imageExtensions = '*.jpg;*.JPG;*.png;*.PNG;*.gif;*.GIF;*.tiff;*.TIFF'
  /** Whitelist for GPS data extensions
   * @property gpsExtensions
   */
  var gpsExtensions = '*.gpx;*.GPX;*.tcx;*.TCX;*.kml;*.KML;*.kmz;*.KMZ;*.fit;*.FIT;*.zip;*.ZIP;*.gz;*.GZ;*.tar;*.TAR';
  /**
   * Set a global property in the rwgps module.
   * @method set
   * @param {String | Object} key As a string, specifies the property to set. Otherwise, expects an object with property/value pairs for mass assignment.
   * @param {MIXED} val (optional, only use if passing a single string key) The value to assign
   */
  function set(key, val) {
    if(key && val) {
      options[key] = val;
    } else{
      // only 1 param, expected to be an object with multiple properties to set
      $.extend(options, key);
    }
  }
  /**
   * Get a global property from the rwgps module.
   * @method get
   * @param {String} key The property to get
   * @return {MIXED} The value associated with the specified property
   */
  function get(key, val) {
    return options[key] = val;
  }
  /** Get the path to POI icons.
   * FIXME This should be somewhere else!
   * @method poiIconsPath
   * @return {String} Base href for POI icons (based on the site)
   */
  function poiIconsPath() {
    if(rwgps.site == 'gi') {
      return 'gi/poi/negativ_med_ramme/';
    } else {
      return 'poi_icons/';
    }
  }
  /**
   * Access/extend namespaces within the rwgps object. Generally for scoping view-specific code.
   * Convention for namespaces is lower camel, e.g. scheduledReports.show
   * @method ns
   * @static
   * @param {String} ns Period-separated namespace, e.g. foo.bar.baz.
   * @param {Object | Function} obj If an object, extends the namespace with it. If a function, runs the function in the context of the namespace, and if the function returns an object, extends the namespace with that return value.
   * @return {Object} The resulting namespace. rwgps.ns('foo.bar.baz') returns rwgps.foo.bar.baz after ensuring it exists.
   */
  // all namespaces get this as their basic object
  var baseNsObj = {ns: function() { return this._ns; }};
  function ns(ns, obj) {
    var nsResolved = resolveNamespace(ns);
    if(obj) {
      if(_.isFunction(obj)) obj = obj.apply(nsResolved);
      if(obj !== undefined) _.extend(resolveNamespace(ns), obj);
      // by convention a property named init will execute after dom ready,
      // but only for the active namespace
      // TODO: uncomment when you uncomment the other activeNamespace stuff
      //if(ns == rwgps.activeNamespace() && obj.init) $(obj.init);
    }
    return nsResolved;
  }
  // namespaces are specified as period-separated strings like so: foo.bar.baz
  // they resolve to something like rwgps.foo.bar.baz respectively
  // objects are created if they do not exist - in other words, nested namespaces are created upon declaration
  function resolveNamespace(nsStr) {
    var nsResolved = rwgps, nsStrMemo;
    _.each(nsStr.split('.'), function(x) {
      nsStrMemo = nsStrMemo === undefined ? x : nsStrMemo + '.' + x;
      if(nsResolved[x] === undefined) nsResolved[x] = _.extend({_ns: nsStrMemo}, baseNsObj);
      nsResolved = nsResolved[x];
    });
    return nsResolved;
  }

  /**
   * A backbone.js-driven model facilitating validation, persistence, and event handling.
   *
   * @class Model
   */
  /**
   * The attributes of the model. Do not modify through this, use set().
   * @property attributes
   */
  /**
   * Commit changes to the model back to the server to be saved.
   * @method save
   */
  /**
   * Setter for model attributes.
   * @method set
   * @param {Object} attributes A hash of attributes to set on the model
   */
  /**
   * Getter individual model attributes.
   * @method get
   * @param {String} attribute The attribute to get the current value of
   */
  /**
   * Get a copy of all attributes.
   * @method toJSON
   * @return {Object} All model attributes contained in an object
   */
  /**
   * Permanently delete this model on the server.
   * @method destroy
   */

  /**
   * @namespace rwgps.models
   */
  /**
   * A route is a list of connected points in physical space, with associated metadata.
   *
   * This class provides static methods to retrieve one or more routes in a variety of ways.
   * An instance of this class represents a single route and provides facilities for modification
   * and retrieval of related objects.
   * @class Route
   * @extends Model
   */
  var Route = Backbone.Model.extend({
    /**
     * Get a full representation of the route, including track points
     * @method full
     * @return {Promise} a promise for the full Route instance
     */
    full: function() {
      if(this.fullDfd) return this.fullDfd.promise();
      var dfd = this.fullDfd = new $.Deferred();

      if (this.attributes.course_points) {
        var route = new rwgps.models.Route(this.attributes);
        route.set('mappingRoute', new rwgps.Route(this.attributes));
        dfd.resolve(route);
        return dfd.promise()
      } // if we have course points, we assume the route is already 'full'

      var uri = baseURL + '/routes/' + this.get('id') + '.json';
      if(this.get('privacy_code_string'))
        uri += '?privacy_code=' + this.get('privacy_code_string');
      $.getJSON(uri, function(data) {
        if(data) {
          var route = new rwgps.models.Route(data);
          route.set('mappingRoute', new rwgps.Route(data));
          dfd.resolve(route);
        } else {
          dfd.reject();
        }
      });

      return dfd.promise();
    },
    /**
     * Get the URL to the GPX file for this route.
     * @method gpxUrl
     */
    gpxUrl: function() {
      return baseURL + '/routes/' + this.get('id') + '.gpx';
    },
    /**
     * Get the URL to the TCX file for this route.
     * @method tcxUrl
     */
    tcxUrl: function() {
      return baseURL + '/routes/' + this.get('id') + '.tcx';
    },
    /**
     * Get the URL to the KML file for this route.
     * @method kmlUrl
     */
    kmlUrl: function() {
      return baseURL + '/routes/' + this.get('id') + '.kml';
    },
    csvUrl: function() {
      return baseURL + '/routes/' + this.get('id') + '.csv';
    },
    printCueSheetUrl: function() {
      return 'https://ridewithgps.com/routes/' + this.get('id') + '/cue_sheet';
    },
    printMapUrl: function() {
      return 'https://ridewithgps.com/routes/' + this.get('id') + '/full.gif';
    },
    embedSrc: function() {
      return '<iframe src="https://ridewithgps.com/routes/' + this.get('id') + '/embed" height="500px" width="100%" frameborder="0"></iframe>';
    },
    /**
     * Send details about this route to an email address.
     * @method emailTo
     * @param {String} email Recipient email address
     * @return {Promise} A promise for this request which will resolve after the email has been confirmed sent.
     */
    emailTo: function(email) {
      var self = this,
          dfd = new $.Deferred();

      $.getJSON(baseURL + '/share.js?callback=?', {site: options.site, share: {email: email, model: 'Route', id: self.get('id')}}, function(data) {
        if(data.success) {
          dfd.resolve();
        } else {
          dfd.reject();
        }
      });

      return dfd.promise();
    },

    copy: function() {
      var self = this,
          dfd = new $.Deferred();

      $.getJSON(baseURL + '/routes/' + self.get('id') + '/copy.js?callback=?', function(data) {
        if(data) {
          dfd.resolve();
        } else {
          dfd.reject();
        }
      });

      return dfd.promise();
    },

    remember: function() {
      var self = this,
          dfd = new $.Deferred();

      $.getJSON(baseURL + '/remember/route/' + self.get('id') + '.js?callback=?', function(data) {
        if(data) {
          dfd.resolve();
        } else {
          dfd.reject();
        }
      });

      return dfd.promise();
    }

  });

  /**
   * Search for routes based on many conditions.
   * @method search
   * @static
   * @param {Object} params A set of options that determine how to perform the search.
   * @param {Function} fn Function to call when search is completed. Will be passed one parameter, the search results, as an array of Route objects.
   */
  Route.search = function(params, fn) {
    $.getJSON(baseURL + '/routes/search.js?callback=?', params, function(data) {
      var results = [];
      for(var i=0, len=data.length; i < len; i++) {
        results.push( new Route(data[i]) );
      }
      fn(results);
    });
  }

  /**
   * Fetch a single route by id
   * @method find
   * @static
   * @param {int} id of route to fetch
   * @return {Route | null} Route with specified id, or null if there is no such route
   */
  Route.find = function(id) {
    var dfd = new $.Deferred();

    $.getJSON(baseURL + '/routes/' + id + '.js?attrs=true&callback=?', function(data) {
      if(data) {
        dfd.resolve(new rwgps.models.Route(data));
      } else {
        dfd.reject();
      }
    });

    return dfd.promise();
  }


  /**
   * Provides rendering and manipulation of maps.
   * @class Map
   */
  /**
   * Initializes a map in a target DOM element. Accepts an options object that can be used to determine initial Map configuration.
   * @constructor
   * @param {String} targetId Expects an id value that corresponds to a DOM element that will be the container for the rendered map
   * @param {Object} config (optional) Config object that specifies initial configuration of map
   */
  function Map(targetId, config) {
    if(!config) config = {
      defaultLat: 43.99490,
      defaultLng: -123.08841
    };
    this.config = config;
    this.targetId = targetId;

    // this should be an option
    MapJs.metric = config.metric = true;

    /**
     * ID of route currently displayed
     * @property routeId
     * @type int
     */
    var routeId = config.routeId;

    if(routeId) {
      MapJs.createMode = false;
      this.loadRoute(routeId, config.coursePointsFn);
    } else if(config.plan) {
      MapJs.createMode = true;
    }
  }


  /**
   * Default configuration for a newly instantiated Map. All configuration properties can be overridden upon instantiation through the config parameter on the Map constructor.
   * @static
   * @property DEFAULT_CONFIG
   * @type Object
   */
  Map.DEFAULT_CONFIG = {
    routeId: null
  };

  Map.prototype = {
    /**
     * Save route that is being planned
     * @method saveRoute
     * @param {Object} attrs Metadata to save as properties of the route
     * @param {String} redirectUrl URL to redirect the user to after route is saved. Will be appended with ?route_id=#route_id#
     */
    saveRoute: function(attrs, redirectUrl) {
      var baseAttrs = {
        route_data: MapJs.movie().routeJSON(),
        course_points: MapJs.movie().coursePointsJSON()
      };
      var $form = $('<form action="' + baseURL + '/routes.json" method="POST"></form>');
      var $field = $('<input type="hidden" name="redirect_to">');
      $form.append($field);
      $field.val(redirectUrl);
      _.each(['route_data', 'points_of_interest', 'course_points'], function(attr) {
        var $field = $('<input type="hidden" name="' + attr + '">');
        $form.append($field);
        $field.val(baseAttrs[attr]);
      });
      _.each(['name', 'description', 'pavement_type_id', 'visibility'], function(attr) {
        var $field = $('<input type="hidden" name="route[' + attr + ']">');
        $form.append($field);
        $field.val(attrs[attr]);
      });
      $('body').append($form);
      $form.submit();
    },

    /**
     * Load a route into the map by route ID
     * @method loadRoute
     * @param {int} routeId The ID of the route to fetch and display
     * @param {Function} fn Function to call when coursepoints are loaded
     */
    loadRoute: function(routeId, fn) {
      this.routeId = routeId;
      $.getJSON(baseURL + '/routes/' + routeId + '.js?string=1&include_cps=1&callback=?', function(data) {
        MapJs.callWhenReady(function() {
          MapJs.movie().loadRoute(data[0], JSON.stringify(data[1]));
        });
        _.each(data[1], function(cp) {
          cp.notes = cp.n;
          cp.distance = cp.d;
        });

        if(fn) fn(data[1]);
      });
    },

    _drawingMode: 'directions', // default
    drawingMode: function(mode) {
      if(!mode) return this._drawingMode;

      if(mode == 'directions' || mode == 'polyline') {
        this._drawingMode = mode;
        MapJs.callWhenReady(function() { MapJs.movie().setDrawingMode(mode); });
      }
    },

    setColor: function(color) {
      MapJs.callWhenReady(function() { MapJs.movie().setColor(color); });
    },

    gotoLocation: function(query) {
      MapJs.callWhenReady(function() { MapJs.movie().gotoLocation(query); });
    },

    showCoursePointMarker: function(id) {
      MapJs.callWhenReady(function() { MapJs.movie().showCoursePointMarker(id); });
    },

    hideCoursePointMarker: function(id) {
      MapJs.callWhenReady(function() { MapJs.movie().hideCoursePointMarker(id); });
    },

    recenterMap: function() {
      MapJs.callWhenReady(function() { MapJs.movie().recenterMap(); });
    },

    enableAddPoi: function() {
      MapJs.callWhenReady(function() { MapJs.movie().enableAddPoi(); });
    },

    fixCoursePointDistances: function() {
      MapJs.callWhenReady(function() { MapJs.movie().fixCoursePointDistances(); });
    },

    enableAddCoursePoint: function() {
      MapJs.callWhenReady(function() { MapJs.movie().enableAddCoursePoint(); });
    },

    walkingMode: function(bool) {
      MapJs.callWhenReady(function() { MapJs.movie().walkingMode(bool); });
    },

    setOption: function(k,v) {
      MapJs.callWhenReady(function() { MapJs.movie().setOption(k,v); });
    }
  };

  /**
   * Listen for or trigger metricsChange event.
   * @method metricsChange
   * @static
   * @param {Function} fn Function to call when metricsChange is triggered. If not provided, triggers metricsChange.
   */
  Map.metricsChange = function(fn) {
    if(fn) {
      if(!this.onMetricsChange) this.onMetricsChange = [];
      this.onMetricsChange.push(fn);
    } else {
      // trigger event
      if(this.onMetricsChange) _.each(this.onMetricsChange, function(fn) { fn(Map.metrics, Map.zoomedIn); });
    }
  };
  /**
   * Listen for or trigger coursePointsChange event.
   * @method coursePointsChange
   * @static
   * @param {Function} fn Function to call when coursePointsChange is triggered. If not provided, triggers coursePointsChange.
   */
  Map.coursePointsChange = function(fn) {
    if(fn) {
      if(!this.onCoursePointsChange) this.onCoursePointsChange = [];
      this.onCoursePointsChange.push(fn);
    } else {
      // trigger event
      if(this.onCoursePointsChange) _.each(this.onCoursePointsChange, function(fn) { fn(Map.coursePoints); });
    }
  };

  Map.updateMetrics = function(metrics, zoomedIn) {
    this.metrics = metrics;
    this.zoomedIn = zoomedIn;
    this.metricsChange();
  };

  Map.updateCoursePoints = function(coursePoints, append) {
    if(!this.coursePoints) this.coursePoints = [];
    this.coursePoints = append ? this.coursePoints.concat(coursePoints) : coursePoints;
    this.coursePointsChange();
  };

  // when metrics or coursepoints update from the map, store them on the Map statically since maps are a singleton resource for time being
  Routes.Common.updateMetrics = function(metrics, zoomedIn) {
    Map.updateMetrics(metrics, zoomedIn);
  }
  Routes.Common.populateCoursePoints = function(coursePoints, append) {
    Map.updateCoursePoints(coursePoints, append);
  }

  /**
   * A User from the RWGPS service.
   *
   * @class User
   * @extends Model
   */
  var User = Backbone.Model.extend({
    url: function() {
      if(this.id)
        return baseSecureURL + '/users/' + this.id + '.js';
      else
        return baseSecureURL + '/users.js';
    },

    /**
     * Fetch a user's routes
     * @method routes
     * @return {Promise} A promise for an array of routes belonging to this user.
     */
    routes: function() {
      var dfd = new $.Deferred();

      if(this._routes) {
        dfd.resolve(this._routes);
        return
      }

      $.getJSON(baseURL + '/users/' + this.id + '/routes.js?callback=?', function(data) {
        if(data) {
          this._routes = _.map(data, function(r) { return new rwgps.Route(r); });
          dfd.resolve(this._routes);
        } else {
          dfd.reject();
        }
      });

      return dfd.promise();
    },

    /**
     * Fetch a user's favorited routes
     * @method routes
     * @return {Promise} A promise for an array of routes favoritied by this user.
     */
    favoriteRoutes: function() {
      var dfd = new $.Deferred();

      if(this._favoriteRoutes) {
        dfd.resolve(this._routes);
        return
      }

      $.getJSON(baseURL + '/users/' + this.id + '/favorite_routes.js?callback=?', function(data) {
        if(data) {
          this._favoriteRoutes = _.map(data, function(r) { return new rwgps.Route(r); });
          dfd.resolve(this._favoriteRoutes);
        } else {
          dfd.reject();
        }
      });

      return dfd.promise();
    }

  });

  // need to override sync so we can use jsonp
  var originalSync = Backbone.sync;
  Backbone.sync = function(method, model, success, error) {
    if(method == 'create' && model instanceof rwgps.models.User ) {
      $.getJSON(baseSecureURL + '/users.js?callback=?', {_method: 'POST', user: model.toJSON()}, function(data) {
        if(data.user) {
          success(data.user);
        } else if(data.errors) {
          error(data.errors);
        }
      });
    } else {
      originalSync.apply(this, arguments);
    }
  };

  /**
   * Login a user by username and password
   * @method login
   * @static
   * @param {String} username Username to attempt login for
   * @param {String} password Password to attempt login with
   * @return {Promise} A promise for the authenticated user. If login fails, promise will be rejected.
   */
  User.login = function(email, password) {
    var self = this,
        dfd = new $.Deferred();

    $.getJSON(baseSecureURL + '/login.js?callback=?', {email:email, password:password}, function(data) {
      if(data) {
        delete self.currentDfd;
        self.current = new User(data);
        dfd.resolve(self.current);
      } else {
        dfd.reject();
      }
    });

    return dfd.promise();
  }

  /**
   * Request a password reset
   * @method resetPassword
   * @static
   * @param {String} username Username to reset password for
   * @return {Promise} A promise for the password reset response
   */
  User.resetPassword = function(email) {
    var dfd = new $.Deferred();

    $.getJSON(baseURL + '/forgot_password.js?callback=?', {site: options.site, email:email}, function(data) {
      if(data && data.status == 1) {
        dfd.resolve();
      } else {
        dfd.reject();
      }
    });

    return dfd.promise();
  }

  User.usePasswordReset = function(identifier, password) {
    var dfd = new $.Deferred();

    $.getJSON(baseSecureURL + '/reset_password/' + identifier + '.js?callback=?', {
      'user[password]': password,
      'user[password_confirmation]': password
    }, function(data) {
      if(data) {
        dfd.resolve();
      } else {
        dfd.reject();
      }
    });

    return dfd.promise();
  }

  /**
   * Log out current user
   * @method logout
   * @static
   * @return {Promise} A promise that resolves when the user is logged out
   */
  User.logout = function() {
    var self = this,
        dfd = new $.Deferred();

    $.getJSON(baseURL + '/logout.js?callback=?', function() {
      delete self.currentDfd;
      dfd.resolve();
    });
    return dfd.promise();
  }

  /**
   * Get currently logged in user
   * @method getCurrent
   * @static
   * @return {Promise} A promise for the currently authenticated user
   */
  User.getCurrent = function() {
    if(this.currentDfd)
      return this.currentDfd;

    var dfd = this.currentDfd = new $.Deferred();
    // we might already have a user prepopulated, let's check
    if(rwgps.ns('config').currentUser !== undefined) {
      if(rwgps.config.currentUser) {
        dfd.resolve(new User(rwgps.config.currentUser)); // we have a user
      } else {
        dfd.reject(); // user is not logged in
      }
    } else {
      $.getJSON(baseURL + '/users/current.js?callback=?', function(data) {
        if(data) {
          dfd.resolve(new User(data));
        } else {
          dfd.reject();
        }
      });
    }
    return dfd;
  }

  /*** export public properties ***/
  _.extend(rwgps, {
    site: site,
    imageExtensions: imageExtensions,
    gpsExtensions: gpsExtensions,
    imageExtRegEx: imageExtRegEx,
    gpsExtRegEx: gpsExtRegEx,
    set: set,
    get: get,
    ns: ns,
    // need to keep these root level for backward compatibility with yha
    //      Route: Route,
    //      Map: Map,
    User: User,
    // this should be somewhere else
    poiIconsPath: poiIconsPath,
    places: {}
  });
  _.extend(rwgps, data_module);
  _.extend(rwgps, date_ext_module);
  _.extend(rwgps, units_module);
  _.extend(rwgps, utils_module);
  rwgps.MetricsCalculator = MetricsCalculator;
  rwgps.ns('Events', Backbone.Events);
  rwgps.ns('models', {
    Route: Route,
    Map: Map,
    User: User
  });
  rwgps.ns('config').datePickerOpts = {
    buttonImage: '/images/led-icons/calendar_1.png',
    buttonImageOnly: true,
    beforeShow: function (input) {
      input.setAttribute('autocomplete', 'off');
      setTimeout(function () {
        $("#ui-datepicker-div").css({"z-index": 11000});
      }, 10)
    },
    showOn: 'both',
    dateFormat: 'yy-mm-dd'
  };
  if(window.activeRWNamespace) {
    rwgps.activeNs = rwgps.ns(window.activeRWNamespace);
  }
  if(window.rwgpsNSData) {
    window.rwgpsNSData.forEach(function(keyVal) {
      rwgps.ns(keyVal[0], keyVal[1]);
    });
  }
}



// WEBPACK FOOTER //
// ./public/javascripts/rwgps/rwgps.js